export enum ICON_TYPE {
	DOWNTREND = "/svg/down-trend-icon.svg",
	EMAIL = "/svg/email-icon.svg",
	GEAR = "/svg/gear-icon.svg",
	NAME = "/svg/name-icon.svg",
	PASSWORD = "/svg/password-icon.svg",
	PHONE = "/svg/phone-icon.svg",
	SEARCH = "/svg/search-icon.svg",
	IMAGE = "/svg/image-placeholder.svg",
	CUSTOMER_PLACEHOLDER = "/svg/customer-placeholder.svg",
	CROSS = "/svg/cross-icon.svg",
	DROP_DOWN_INDICATOR = "/svg/drop-down-indicator.svg",
	PAGINATION_ARROW = "/svg/pagination-arrow.svg",
	GREEN_CHECK = "/svg/icon-green-check.svg",
	CALENDAR = "/svg/icon-calendar.svg",
	CHEVRON = "/svg/chevron.svg",
	IMAGE_ICON = "/svg/image-icon.svg",
	UPLOAD_ICON = "/svg/upload-icon.svg",
	REMOVE_ICON = "/svg/remove-icon.svg",
	WHITE_CHECK = "/svg/white-check-icon.svg",
	WHITE_CROSS = "/svg/white-cross.svg",
	RED_CROSS_CIRCLE = "/svg/red-cross-circle.svg",
	MESSAGE_ICON = "/svg/message-icon.svg",
	NOTES_ICON = "/svg/notes-icon.svg",
	GREEN_CHECK_CIRCLE = "/svg/green-check-circle.svg",
	BLUE_HORIZONTAL_DOTS_CIRCLE = "/svg/horizontal-dots-circle.svg",
}
